// 認証サービス
class AuthService {
  constructor() {
    this.users = [];
    this.currentUser = null;
    this.loadUsers();
  }

  // ユーザーデータを読み込み（CSV優先 + ハードコーディングフォールバック）
  async loadUsers() {
    try {
      // CSVファイルから直接読み込み（ローカルストレージは無視）
      try {
        const csvResponse = await fetch('/data/users.csv');
        const csvText = await csvResponse.text();
        const csvUsers = this.parseUsersCSV(csvText);
        
        // ハードコーディングされた管理者ユーザーを追加
        const hardcodedUsers = [
          {
            id: 999,
            username: "admin",
            password: "Adm1n#Pw",
            email: "admin@example.com",
            name: "管理者",
            role: "admin"
          },
          {
            id: 998,
            username: "root",
            password: "Adm1n#Pw",
            email: "root@example.com",
            name: "ルート管理者",
            role: "admin"
          }
        ];
        
        // CSVユーザーとハードコーディングユーザーを結合
        this.users = [...csvUsers, ...hardcodedUsers];
        console.log('CSVファイルからユーザーデータを読み込みました（ハードコーディングユーザー含む）:', csvUsers);
      } catch (csvError) {
        console.log('CSVファイルの読み込みに失敗、ハードコーディングユーザーのみ使用');
        // CSVファイルが失敗した場合はハードコーディングユーザーのみ
        this.users = [
          {
            id: 999,
            username: "admin",
            password: "Adm1n#Pw",
            email: "admin@example.com",
            name: "管理者",
            role: "admin"
          },
          {
            id: 998,
            username: "root",
            password: "Adm1n#Pw",
            email: "root@example.com",
            name: "ルート管理者",
            role: "admin"
          }
        ];
        console.log('ハードコーディングされたユーザーデータのみ読み込みました');
      }
    } catch (error) {
      console.error('ユーザーデータの読み込みに失敗しました:', error);
    }
  }

  // CSVファイルを解析
  parseUsersCSV(csvContent) {
    const lines = csvContent.split('\n');
    if (lines.length < 2) return [];

    const headers = lines[0].split(',').map(h => h.trim());
    const users = [];

    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;

      const values = this.parseCSVLine(line);
      if (values.length >= headers.length) {
        const user = {};
        headers.forEach((header, index) => {
          user[header] = values[index] || '';
        });
        users.push(user);
      }
    }

    return users;
  }

  // CSV行を解析（カンマ区切り、ダブルクォート対応）
  parseCSVLine(line) {
    const values = [];
    let current = '';
    let inQuotes = false;
    
    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      
      if (char === '"') {
        if (inQuotes && line[i + 1] === '"') {
          current += '"';
          i++; // 次のダブルクォートをスキップ
        } else {
          inQuotes = !inQuotes;
        }
      } else if (char === ',' && !inQuotes) {
        values.push(current.trim());
        current = '';
      } else {
        current += char;
      }
    }
    
    values.push(current.trim());
    return values;
  }



  // ログイン処理
  async login(username, password) {
    const user = this.users.find(u => 
      u.username === username && u.password === password
    );

    if (user) {
      // パスワードを除いたユーザー情報を保存
      const { password, ...userWithoutPassword } = user;
      this.currentUser = userWithoutPassword;
      
      // ローカルストレージに保存
      localStorage.setItem('currentUser', JSON.stringify(userWithoutPassword));
      localStorage.setItem('isLoggedIn', 'true');
      
      return { success: true, user: userWithoutPassword };
    } else {
      return { success: false, message: 'ユーザー名またはパスワードが正しくありません' };
    }
  }

  // ログアウト処理
  logout() {
    this.currentUser = null;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('isLoggedIn');
  }

  // 現在のユーザーを取得
  getCurrentUser() {
    if (!this.currentUser) {
      const storedUser = localStorage.getItem('currentUser');
      if (storedUser) {
        this.currentUser = JSON.parse(storedUser);
      }
    }
    return this.currentUser;
  }

  // ログイン状態を確認
  isLoggedIn() {
    return localStorage.getItem('isLoggedIn') === 'true' && this.getCurrentUser();
  }

  // 管理者権限を確認
  isAdmin() {
    const user = this.getCurrentUser();
    return user && user.role === 'admin';
  }
}

const authService = new AuthService();
export default authService; 